import { render, staticRenderFns } from "./MemberDetailView.vue?vue&type=template&id=5f963fe7&scoped=true"
import script from "./MemberDetailView.vue?vue&type=script&lang=js"
export * from "./MemberDetailView.vue?vue&type=script&lang=js"
import style0 from "./MemberDetailView.vue?vue&type=style&index=0&id=5f963fe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f963fe7",
  null
  
)

export default component.exports